/*
 * Author M. Atoar Rahman
 * Title: D3 Report
 * Description: Index for D3 Report
 * Date: 05/06/2022
 */

import { Card } from 'react-bootstrap';
import { useD3Report } from './ContextAPI';
import FormInfo from './FormInfo';
import PrintIndex from './pdf/PrintIndex';
import ShowModel from './ShowModel';

export default function Index() {
    const { show, showPdf } = useD3Report();

    if (showPdf) return <PrintIndex />;

    return show ? (
        <Card>
            <Card.Body>
                <ShowModel />
            </Card.Body>
        </Card>
    ) : (
        <FormInfo />
    );
}
